export default {"src":"/_next/static/media/real-time_metrics_dynamic_dashboards.ac2d0cf4.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};